import { CrudAction, ModalStatus, ObjectStatus } from '@shared/models/app-global-constants';
import { environment } from 'src/environments/environment';

export var global = {
  url: environment.API_URL,
};

export class NodeConstants {
  static nodeTypesIds = {
    router: 1,
    antenna: 2,
  };
}

export class AppGlobalConstants {
  static nodeTypesIds = {
    router: 1,
    antenna: 2,
  };

  static crudActions: CrudAction = {
    create: 'CREATE',
    read: 'READ',
    update: 'UPDATE',
    delete: 'DELETE',
  };

  static appModals = {
    site: 'site',
    ipv4Pool: 'ipv4Pool',
    router: 'router',
    antenna: 'antenna',
    tower: 'tower',
  };

  static modalStatus: ModalStatus = {
    opened: 1,
    closed: 0,
    waiting: -1,
  };

  static objectStatus: ObjectStatus = {
    active: 'ACTIVO',
    inactive: 'INACTIVO',
    deleted: 'ELIMINADO',
  };
}
